// extracted by mini-css-extract-plugin
export default {"container":"style_container__vTETR","header":"style_header__sYAmA","text":"style_text__R8MiQ"};